import React, {useState} from 'react';
import "./header.css";
import CV from "../../assets/CV_Wanjia_Fu.pdf";

const Header = () => {
        /* ========== Toggle Menu ========== */
        const[Toggle, showMenu] = useState(false);

        const scrollToSection = (event, sectionId) => {
            event.preventDefault();
            showMenu(false);

            const element = document.getElementById(sectionId);
            if (!element) return;

            const target =
                element.classList.contains('section__title') ||
                element.classList.contains('about__title')
                    ? element
                    : element.querySelector('.section__title') ??
                      element.querySelector('.about__title') ??
                      element;

            const header = document.querySelector('.header');
            const headerOffset = header ? header.offsetHeight + 16 : 80;
            const top =
                target.getBoundingClientRect().top +
                window.scrollY -
                headerOffset;

            window.scrollTo({ top, behavior: 'smooth' });
            window.history.pushState(null, '', `#${sectionId}`);
        };

    return (
        <header className="header">
                <nav className="nav container">
                    <a href="#about" className="nav__logo" onClick={(e) => scrollToSection(e, 'about')}>Wanjia Fu</a>

                    <div className={Toggle ? "nav__menu show-menu" : 
                    "nav__menu"}>
                        <ul className="nav__list grid">
                            <li className="nav__item">
                                <a href="#about" className="nav__link active-link" onClick={(e) => scrollToSection(e, 'about')}>
                                    <i className="uil uil-user nav__icon"></i> Home
                                </a>
                            </li>
                            <li className="nav__item">
                                <a href="#news" className="nav__link" onClick={(e) => scrollToSection(e, 'news')}>
                                    <i className="uil uil-news nav__icon"></i> News
                                </a>
                            </li>
                            <li className="nav__item">
                                <a href="#research" className="nav__link" onClick={(e) => scrollToSection(e, 'research')}>
                                    <i className="uil uil-research nav__icon"></i> Publications
                                </a>
                            </li>
                            <li className="nav__item">
                                <a download="" href={CV} className="nav__link">
                                    <i className="uil uil-file-alt nav__icon"></i> CV
                                </a>
                            </li>
                         </ul>

                        <i class="uil uil-times nav__close" onClick={() => showMenu 
                        (!Toggle)}></i>
                    </div>

                    <div className="nav__toggle" onClick={() => showMenu 
                        (!Toggle)}>
                        <i class="uil uil-apps"></i>
                    </div>
                </nav>
        </header>
    )
}

export default Header